export const hideGames = ['pin_up_cafe', 'buffalo_1xbet'];

const tabs = {
  nuevo: ['long_neck', 'mummy_mines', 'chinese_panda', 'cafe_50s', 'make_gold', 'fishing'],
  halloween: [
    'digger_halloween',  // Halloween Crystals - Belatra
    'halloween', // Halloween - Belatra
    'voodoo', // Voodoo Coins
    'fortune_mummy', // Fortune Mummy
    'mummyland', // MummyLand Treasures
    'mummy_mines', // Mummys Mines
  ],
};

export function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}
